import styled from 'styled-components'

const StyledLoadingBar = styled.div`
  width: 100px;
  height: 3px;
  margin-top: 24px;
  position: relative;
  overflow: hidden;
  background: var(--color-background-loading-015);
  border-radius: 2px;
  &::before {
    content: '';
    width: 35px;
    height: 3px;
    background: var(--color-primary-primary);
    position: absolute;
    left: -34px;
    -webkit-animation: bluebar 1.5s infinite ease;
    animation: bluebar 1.5s infinite ease;
  }
`
const StyledContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  text-align: center;
  z-index: 999999;
  .preloader-wrap img {
    width: 48px;
    height: 48px;
  }
`
const AmazLoading = () => {
  return (
    <StyledContainer id="preloader">
      <div className="preloader-wrap">
        <img src="/images/ic-logo-green.svg" alt="logo" />
        <StyledLoadingBar className="loading-bar" />
      </div>
    </StyledContainer>
  )
}

export default AmazLoading
